import MainPage from "../templatePage/templatePage";
import ManageUserLessons from "./ManageUserLessons";
import ErrorBoundary from "../common/ErrorBoundary";

const UserLessonsPage = () => {
    return (
        <MainPage 
            component={
                <ErrorBoundary>
                    <ManageUserLessons />
                </ErrorBoundary>
            } 
        />
    );
};

export default UserLessonsPage;
